<script setup lang="ts">
import { useCityStore } from '@/store/city/city'

import FooterInfoPaymentCards from '@/components/Footer/footer-info/FooterInfoPaymentCards.vue'
import FooterInfoSocialNetworks from '@/components/Footer/footer-info/FooterInfoSocialNetworks.vue'

const APP_VERSION = 'v2.0.0'

const { socialNetworks, copyright } = useCityStore()
</script>

<template>
  <section class="footer-info">
    <div class="footer-info__copyright">
      &#169; {{ copyright }} {{ APP_VERSION }}
    </div>

    <div class="footer-info__requisites">
      Данные о продавце в разделе
      <nuxt-link :prefetch="false" to="/info/#requisites/">Реквизиты</nuxt-link>
    </div>

    <footer-info-payment-cards class="footer-info__cards" />

    <footer-info-social-networks :social-networks="socialNetworks" />
  </section>
</template>

<style lang="scss" scoped>
.footer-info {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px 0;
  align-items: center;
  padding: 40px 0;
  color: $text-grey;

  &__copyright {
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
  }

  &__requisites {
    font-size: 12px;
    font-weight: 500;
    line-height: 12px;

    a {
      color: $text-grey;
      text-decoration: underline;
    }
  }

  @include media('>desktop-mini') {
    display: flex;
    gap: 0;
    padding: 30px 0 40px;

    &__copyright {
      margin-right: 65px;
    }

    &__requisites {
      margin-right: 270px;
    }

    &__cards {
      margin-right: 130px;
    }
  }
}
</style>
